import { CHART_PLOTLY_STRINGS } from "./constantStrings";

const getDownloadButton = onDownloadPlot => {
  const icon = {
    width: 500,
    height: 500,
    path: "M480 352h-133.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456zM233.4 374.6C239.6 380.9 247.8 384 256 384s16.38-3.125 22.62-9.375l128-128c12.49-12.5 12.49-32.75 0-45.25c-12.5-12.5-32.76-12.5-45.25 0L288 274.8V32c0-17.67-14.33-32-32-32C238.3 0 224 14.33 224 32v242.8L150.6 201.4c-12.49-12.5-32.75-12.5-45.25 0c-12.49 12.5-12.49 32.75 0 45.25L233.4 374.6z"
  };
  return {
    name: CHART_PLOTLY_STRINGS.downloadCSV,
    icon,
    click: () => onDownloadPlot()
  };
};

const getRefreshButton = onPlotRefresh => {
  const icon = {
    width: 500,
    height: 500,
    path: "M449.9 39.96l-48.5 48.53C362.5 53.19 311.4 32 256 32C161.5 32 78.59 92.34 49.58 182.2c-5.438 16.81 3.797 34.88 20.61 40.28c16.97 5.5 34.86-3.812 40.3-20.59C130.9 138.5 189.4 96 256 96c37.96 0 73 14.18 100.2 37.8L311.1 178C295.1 194.8 306.8 223.4 330.4 224h146.9C487.7 223.7 496 215.3 496 204.9V59.04C496 34.99 466.9 22.95 449.9 39.96zM441.8 289.6c-16.94-5.438-34.88 3.812-40.3 20.59C381.1 373.5 322.6 416 256 416c-37.96 0-73-14.18-100.2-37.8L200 334C216.9 317.2 205.2 288.6 181.6 288H34.66C24.32 288.3 16 296.7 16 307.1v145.9c0 24.04 29.07 36.08 46.07 19.07l48.5-48.53C149.5 458.8 200.6 480 255.1 480c94.45 0 177.4-60.34 206.4-150.2C467.9 313 458.6 294.1 441.8 289.6z"
  };

  return {
    name: CHART_PLOTLY_STRINGS.refreshData,
    icon,
    click: () => onPlotRefresh()
  };
};
const getSpikeLineButton = (onToggleSpikeLine, isSpikeLineActive) => {
  const icon = {
    width: 50,
    height: 50,
    path: "M10 5 H40 A5 5 0 0 1 45 10 V40 A5 5 0 0 1 40 45 H10 A5 5 0 0 1 5 40 V10 A5 5 0 0 1 10 5 Z M10 20 A15 15 0 0 1 40 20 A15 15 0 0 1 10 20 Z"
  };

  return {
    name: isSpikeLineActive ? CHART_PLOTLY_STRINGS.toggleSpikeLineOff : CHART_PLOTLY_STRINGS.toggleSpikeLineOn,
    icon,
    click: () => onToggleSpikeLine(!isSpikeLineActive)
  };
};

export const getPlotlyIcons = (onDownloadPlot, onPlotRefresh, onToggleSpikeLine, isSpikeLineActive, zoomButtons = true) => {
  const toImage = "toImage";
  const modeBarButtons = [toImage];
  if (onDownloadPlot) {
    const button = getDownloadButton(onDownloadPlot);
    modeBarButtons.unshift(button);
  }
  if (onPlotRefresh) {
    const button = getRefreshButton(onPlotRefresh);
    modeBarButtons.unshift(button);
  }
  if (zoomButtons) {
    const zoom2d = "zoom2d";
    const resetScale2d = "resetScale2d";
    modeBarButtons.push(zoom2d, resetScale2d);
  }
  if (onToggleSpikeLine) {
    const spikeLineButton = getSpikeLineButton(onToggleSpikeLine, isSpikeLineActive);
    modeBarButtons.unshift(spikeLineButton);
  }
  return {
    displayModeBar: true,
    displaylogo: false,
    showTips: false,
    modeBarButtons: [modeBarButtons]
  };
};
